
export default function appElementsStoreModule(ext={
  state: {},
  getters:{},
  mutations:{},
  actions:{}
}){
  return {
    namespaced: true,
    state: {
      // layout sidebar, for example for filters
      isVerticalMenuCollapsed: false,
      isVerticalMenuActive: false,

      // content sidebar, for example for add or edit form
      isAddNewElementSidebarCollapsed: false,
      isAddNewElementSidebarActive: true,
      isAddNewElementSidebarBusy: false,

      refetchData: false,
      elementInEdit: null,

      ...ext.state
    },
    getters: {
      ...ext.getters
    },
    mutations: {
      // layout sidebar, for example for filters
      SET_IS_VERTICAL_MENU_COLLAPSED(state, val) {
        state.isVerticalMenuCollapsed = val
      },
      SET_IS_VERTICAL_MENU_ACTIVE(state, val) {
        state.isVerticalMenuActive = val
      },

      // content sidebar, for example for add or edit form
      SET_IS_ADD_NEW_ELEMENT_COLLAPSED(state, val) {
        state.isAddNewElementSidebarCollapsed = val
      },
      SET_IS_ADD_NEW_ELEMENT_ACTIVE(state, val) {
        state.isAddNewElementSidebarActive = val
      },
      SET_IS_ADD_NEW_ELEMENT_BUSY(state, val) {
        state.isAddNewElementSidebarBusy = val
      },

      UPDATE_REFETCH_DATA(state, val) {
        state.refetchData = val
      },

      SET_ELEMENT_IN_EDIT(state, val) {
        state.elementInEdit = val
      },



      ...ext.mutations

    },
    actions: {
      ...ext.actions
    },
  }
}
